import React from 'react';
import { Container, Row, Col } from 'src/interface/basics/grids';
import { LazyImg } from 'src/interface/vendors/lazyload-wrapper';

const Card = ({ className = '', children }) => (
  <div className={`card ${className}`}>{children}</div>
)

const CardHeader = ({ className = '', children }) => (
  <div className={`card-header ${className}`}>{children}</div>
)

const CardImg = ({ src, alt = '', className = '', children }) => (
  <LazyImg src={src} alt={alt + ' photo'} className={`card-img ${className}`}/>
)

const CardBody = ({ className = '', children }) => (
  <div className={`card-body ${className}`}>{children}</div>
)

const CardPretitle = ({ className = 'primary', children }) => (
  <h6 className={`card-pretitle ${className}`}>{children}</h6>
)

const CardTitle = ({ className = 'gray-800', children }) => (
  <h5 className={`card-title ${className}`}>{children}</h5>
)

const CardSubtitle = ({ className = 'gray-400', children }) => (
  <h6 className={`card-subtitle ${className}`}>{children}</h6>
)

const CardText = ({ className = 'gray-700', children }) => (
  <p className={`card-text ${className}`}>{children}</p>
)

const CardFooter = ({ className = 'gray-300 italic', children }) => (
  <div className={`card-footer ${className}`}>{children}</div>
)

export {
  Card,
  CardHeader,
  CardImg,
  CardBody,
  CardPretitle,
  CardTitle,
  CardSubtitle,
  CardText,
  CardFooter
}

// Docs:
// https://react-bootstrap.github.io/components/cards/
